<template>
  <vs-popup class="add-additional-cost-popup"
            id="popup"
            :title="`CREATE INVOICE FOR ${product_order_code}`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <vs-alert class="h-auto mb-8 text-lg" color="danger" v-if="!is_invoice_creatable">
        Please configure the nominal code settings before creating the first invoice.
      </vs-alert>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateInvoice)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="date" name="date" rules="required" v-slot="{ errors }">
                <small class="label">Invoice date <span class="text-danger">*</span></small>
                <flat-pickr style="display: none" :config="{ dateFormat: 'd/m/Y'}" class="w-full" v-model="createForm.date"/>
                <flat-pickr :config="{ dateFormat: 'd/m/Y'}" class="w-full" v-model="createForm.date"/>
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="createForm.note" height="70px"/>
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <vs-table v-if="is_table_visible" :hoverFlat="true" :onlyClickCheckbox="true" multiple v-model="selectedItems" class="mt-8" :data="formulation_items">

            <template slot="header">
              <h5 class="mb-4">Select items</h5>
            </template>

            <template slot="thead">
              <vs-th width="15%">ITS PRODUCT CODE</vs-th>
              <vs-th>FG TYPE</vs-th>
              <vs-th width="15%">TOTAL ITEM QUANTITY (WITH RETURN STOCK) (GRAM)</vs-th>
              <vs-th width="15%">REMAINING QUANTITY (GRAM)</vs-th>
              <vs-th width="10%">SELECTED QUANTITY (GRAM)</vs-th>
              <vs-th width="15%">UNIT PRICE Excl VAT ({{ account_currency }}/KG)</vs-th>
              <vs-th width="15%">TOTAL PRICE Excl VAT ({{ account_currency }})</vs-th>
              <vs-th width="10%">TAX CODE</vs-th>
              <vs-th widht="5%">SAGE DEPARTMENT</vs-th>
              <vs-th>NOMINAL CODE</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr v-if="tr_item.remaining_to_be_quantity > 0" :data="tr_item"  :key="index_item" v-for="(tr_item, index_item) in data">

                <vs-td :data="tr_item.formulation_code">
                  {{ tr_item.formulation_code }}
                </vs-td>

                <vs-td :data="tr_item.type">
                  {{ tr_item.type }}
                </vs-td>

                <vs-td :data="tr_item.quantity">
                  {{ tr_item.quantity }}
                </vs-td>

                <vs-td :data="tr_item.remaining_to_be_quantity">
                  {{ tr_item.remaining_to_be_quantity }}
                </vs-td>

                <vs-td :data="tr_item.quantity">
                  <ValidationProvider :vid="index_item + 'selected_quantity' " :name="index_item + 'selected_quantity'" :rules="`min_qty:${tr_item.remaining_to_be_quantity}`" v-slot="{ errors }">
                    <vs-input type="text" v-model="tr_item.selected_quantity" class="w-full"
                              :name="index_item+'selected_quantity'"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </vs-td>

                <vs-td :data="tr_item.price">
                  {{ tr_item.price | format_price(fx_value) }}
                </vs-td>

                <vs-td :data="tr_item.quantity">
                  {{ (tr_item.selected_quantity ? calculateNetValue(tr_item) : '0.00') }}
                </vs-td>

                <vs-td :data="tr_item.price">

                  <vs-dropdown>

                    <a class="flex items-center">
                      {{ tr_item.tax_code || 'SELECT'}}
                      <i class="material-icons"> expand_more </i>
                    </a>

                    <vs-dropdown-menu style="z-index: 99999">

                      <vs-dropdown-item @click="onClickTaxCode(tax_code.code, tax_code.percent, tr_item.id)" v-for="(tax_code, index) in tax_codes" :key="index">
                        <span>{{tax_code.code}} - {{tax_code.percent}} % </span>
                      </vs-dropdown-item>

                    </vs-dropdown-menu>
                  </vs-dropdown>

                </vs-td>

                <vs-td>
                  <vs-dropdown>

                    <a class="flex items-center">
                      {{ tr_item.sage_department_name || 'SELECT'}}
                      <i class="material-icons"> expand_more </i>
                    </a>
                    <vs-dropdown-menu style="z-index: 99999">

                    <vs-dropdown-item @click="onClickSageDepartment(department.name, department.id, tr_item.id)" v-for="(department, index) in sage_departments" :key="index">
                        <span>{{department.name}}</span>
                    </vs-dropdown-item>

                    </vs-dropdown-menu>

                  </vs-dropdown>
      
                </vs-td>

                <vs-td>
                  {{ formulation_items[index_item].sage_nominal_code ? formulation_items[index_item].sage_nominal_code : 'N/A' }}  
                </vs-td>

              </vs-tr>
            </template>

          </vs-table>

          <vs-table noDataText="Click add to add additional cost" class="mt-8" :data="createForm.add_cost">

            <template slot="header">
              <h5 class="mb-4">Additional cost</h5>
              <div class="flex flex-wrap items-center justify-end mt-8">
                <vs-button @click.stop="onClickAddAddCost()" size="small" class="ml-auto mt-2 mb-4">Add</vs-button>
              </div>
            </template>

            <template slot="thead">
              <vs-th>NAME</vs-th>
              <vs-th>AMOUNT Excl VAT (GBP)</vs-th>
              <vs-th v-if="!__isCurrencyGbp(account_currency)">AMOUNT Excl VAT ({{ account_currency }})</vs-th>
              <vs-th>VAT PERCENTAGE (%)</vs-th>
              <vs-th>NOMINAL CODE</vs-th>
              <vs-th></vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="index_cost" v-for="(tr_cost, index_cost) in data">

                <vs-td :data="tr_cost.name">
                  <ValidationProvider :vid="index_cost+'name'" :name="index_cost+'name'"
                                      rules="required" v-slot="{ errors }">
                    <vs-input type="text" v-model="tr_cost.name"
                              class="w-full"
                              :name="index_cost+'name'" :danger="!!errors[0]" :danger-text="errors[0]"
                              val-icon-danger="icon-x"
                              val-icon-pack="feather"/>
                  </ValidationProvider>
                </vs-td>

                <vs-td :data="tr_cost.amount">
                  <ValidationProvider :vid="index_cost+'amount'" :name="index_cost+'amount'"
                                      rules="required" v-slot="{ errors }">
                    <vs-input type="text" v-model="tr_cost.amount"
                              class="w-full"
                              :name="index_cost+'amount'" :danger="!!errors[0]" :danger-text="errors[0]"
                              val-icon-danger="icon-x"
                              val-icon-pack="feather"/>
                  </ValidationProvider>
                </vs-td>

                <vs-td v-if="!__isCurrencyGbp(account_currency)">
                  {{ tr_cost.amount | format_price(fx_value) }}
                </vs-td>

                <vs-td :data="tr_cost.vat_percent">
                  <ValidationProvider :vid="index_cost+'vat_percent'" :name="index_cost+'vat_percent'"
                                      rules="required" v-slot="{ errors }">
                    <vs-input type="text" v-model="tr_cost.vat_percent"
                              class="w-full"
                              :name="index_cost+'vat_percent'" :danger="!!errors[0]" :danger-text="errors[0]"
                              val-icon-danger="icon-x"
                              val-icon-pack="feather"/>
                  </ValidationProvider>
                </vs-td>

                <vs-td>
                  <!-- <v-select name="sage_nominal_code_id" :closeOnSelect="true" v-model="tr_cost.sage_nominal_code_id" label="code" :reduce="option => option.id"
                    :options="nominal_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" :append-to-body="false"/> -->
                    <select v-model="tr_cost.sage_nominal_code_id" class="v-select">
                      <option v-for="option in nominal_codes" :value="option.id">
                        {{ option.code }}
                      </option>
                    </select>
                </vs-td>

                <vs-td>
                  <div class="vx-row">
                    <vx-tooltip class="ml-2" text="Remove" position="top">
                      <vs-button @click.stop="onClickRemoveAddCost(index_cost)"
                                 size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>

              </vs-tr>
            </template>

          </vs-table>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button :disabled="!is_invoice_creatable" button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <!-- <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button> -->
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import Calculations from '@/mixins/Calculations'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import vSelect from 'vue-select'
  const CustomerRepository = RepositoryFactory.get('customer')
  const TaxRepository = RepositoryFactory.get('tax')
  const SageSettingsRepository = RepositoryFactory.get('sage_settings');

  function initialState() {
    return {
      open: false,
      id: '',
      product_order_code: '',
      createForm: {
        add_cost: [],
      },
      formulation_items: [],
      account_currency: '',
      selectedItems: [],
      add_cost: [],
      tax_codes: [],
      order_invoices: [],
      add_costs: [],
      is_table_visible: false,
      nominal_codes: [],
      listed_nominal_code: [],
      account_currency: '',
      fx_value: 1,
      sage_departments: [],
      customers_order_number: ""
    }
  }

export default {
  name: 'CreateSampleOrderInvoicePopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id, account_currency, fx_value) {
      try {
        Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.id = id
        const { data } = (await CustomerRepository.getSampleOrder(this.id)).data

        // set customer/lead account currency and fx value
        this.account_currency = account_currency
        this.fx_value = fx_value

        this.order_invoices = (await CustomerRepository.getSampleOrderInvoices(this.id)).data.data

        this.order_invoices = this.order_invoices.filter((x) => x.status.name !== 'Cancelled')

        this.product_order_code = data.sample_order_code
        this.customers_order_number = data.customers_order_number
        // this.account_currency = account_currency
        let inv_items = []
        this.order_invoices.forEach((n) => {
          inv_items = inv_items.concat(n.items)
        })
        this.formulation_items = data.formulation_items.map((x) => {
          x.sage_nominal_code_id = null
          x.sage_nominal_code = null
          return x
        })
        this.formulation_items.forEach((n) => {
          let related_inv = inv_items.filter((m) => n.formulation_code === m.formulation_code)
          let related_inv_total = related_inv.reduce((a, b) => a + Number(b.quantity), 0)

          n.quantity = Number(n.quantity)
          n.price = n.price

          n.remaining_to_be_quantity = Number(n.quantity) - Number(related_inv_total)
          n.selected_quantity = n.remaining_to_be_quantity
          n.tax_code = 'Z'
          n.tax_percent = '0.00'
          return n
        })

        await this.fetchTaxCodes()
        await this.generateNominalCode(data.country, data.formulation_items)
        await this.fetchNominalCodes()
        await this.getSageDepartments()
        this.open = true;
      } catch (error) {
        this.convertAndNotifyError(error);
      }
    },
    async getSageDepartments(){
          this.$vs.loading()
          const {data} = await SageSettingsRepository.getListOfSageDepartments('','','',0)
          this.sage_departments =  data.data
          this.$vs.loading.close()
        },
    async generateNominalCode(country, formulation_items) {
      try {
        this.is_table_visible = false
        for (let index = 0; index < formulation_items.length; index++) {
          const element = formulation_items[index];
          const { data } = (await SageSettingsRepository.getListOfSageNominalCodes(1, `filter[formulation_type]=${element.type || 'powder'}&filter[country]=${country}`, 150, 0)).data
          const order_item_nominal_code_list = data.filter((x) => x.is_for_surcharge === false)
          this.formulation_items[index].sage_nominal_code_id = order_item_nominal_code_list.length > 0 ? order_item_nominal_code_list[0].id : null
          this.formulation_items[index].sage_nominal_code = order_item_nominal_code_list.length > 0 ? order_item_nominal_code_list[0].code : null
        }
        this.is_table_visible = true
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    calculateNetValue(item) {
        const quantityInKg = Number(item.selected_quantity) / 1000;
        const unitPrice = Number(this.$options.filters.format_price(item.price, this.fx_value));
        return (quantityInKg * unitPrice).toFixed(2);
      },
    async orderItems() {
      try {
        const { data } = (await CustomerRepository.getCustomerProductOrder(this.id)).data
        this.formulation_items = data.formulation_items

      } catch (error) {
        
      }
    },
    async fetchTaxCodes() {
      this.$vs.loading()
      try {
        const { data } =  await TaxRepository.getListOfTaxCodes(1, '', 150)
        this.tax_codes = data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async fetchNominalCodes() {
      try {
        const { data } = (await SageSettingsRepository.getListOfSageNominalCodes(1, ``, 150, 0)).data
        this.nominal_codes = data
      } catch (error) {
        
      }
    },
    onClickAddAddCost() {
      this.createForm.add_cost.push({ name: null, amount: null })
    },
    onClickRemoveAddCost(index) {
      this.createForm.add_cost.splice(index, 1)
    },

    async onClickCreateInvoice () {
      const vue = this;
      this.$vs.loading()
       try {
         let payload = {}
         this.createForm.add_cost = this.createForm.add_cost.map((n) => {
           n.amount = Number(n.amount).toFixed(2)
           n.vat_percent = Number(n.vat_percent).toFixed(2)
           n.sage_nominal_code_id = n.sage_nominal_code_id || null
           return n
         })
         Object.assign(payload, this.createForm)
         payload.items = this.selectedItems.map((x) => {
           return {
             sample_order_item_id: x.id,
             quantity: Number(x.selected_quantity),
             price: x.price,
             tax_code: x.tax_code,
             tax_percent: x.tax_percent,
             sage_nominal_code_id: x.sage_nominal_code_id || null,
             sage_department_id: x.sage_department_id || null,
           }
         })
         payload.items = payload.items.filter((x) =>  x.quantity !== 0)
         payload.customers_order_number = this.customers_order_number
         await CustomerRepository.createSampleOrderInvoice(this.id, payload)
         this.showSuccessMessage('Invoice created successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.convertAndNotifyError(e)
         this.$vs.loading.close()
       }
      this.$vs.loading.close()
    },
    onClickTaxCode(code, percent, id) {
      this.formulation_items = this.formulation_items.map((x) => {
        if(x.id === id) {
          x.tax_code = code
          x.tax_percent = percent
        }
        return x
      })
    },
    onClickSageDepartment(name, id, formulation_item_id) {
      this.formulation_items = this.formulation_items.map((x) => {
        if(x.id === formulation_item_id) {
          x.sage_department_name = name
          x.sage_department_id = id
        }
        return x
      })
    }
  },
  mixins: [SuccessMessage, ErrorMessages, Calculations],
  components: {
    flatPickr,
    'v-select': vSelect,
  },
  computed: {
    is_invoice_creatable: function() {
      return this.selectedItems.every((x) => x.sage_nominal_code_id)
    }
  }
}
</script>

<style scoped>
  .add-additional-cost-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 70% !important;
  }
  .style-chooser .vs__dropdown-menu {
    z-index:10030 !important;
  }
</style>
